import React from "react";
import Button from "../../Button";
import Overlay from "../../Overlay";
import excalamation from "../../../assets/img/icons/table/excalamation.svg";

function TresorerieLockSuccess({ onConfirm, onCancel, open = true }) {
  const handleCloseDialog = () => {
    onCancel();
  };

  const handleConfirm = async () => {
    await onConfirm();
  };

  return (
    <Overlay show={open} closable={true} onClick={handleCloseDialog}>
      <div className="delete-confirm-wrapper">
        <div className="delete-confirm-container">
          <div className="are-you-sure">
            <img src={excalamation} alt={"excalamation"} />
            <p>Verrouillage du mode trésorerie</p>
          </div>

          <h1 className="popup-desc-content">
            Toutes vos écritures ont un statut « pointé » sur la période à
            verrouiller.
            <br />
            Vous allez verrouiller le mois sélectionné ainsi que tous les mois
            précédents, automatiquement (si ils ne le sont pas déjà).
          </h1>

          <div className="delete-button-containers">
            <Button
              text={"Annuler"}
              onClick={handleCloseDialog}
              className={"action-button action-button-cancel"}
            />
            <Button
              text={"Verrouiller"}
              onClick={handleConfirm}
              className={"action-button agree-action-button"}
            />
          </div>
        </div>
      </div>
    </Overlay>
  );
}

export default TresorerieLockSuccess;
